import { render, staticRenderFns } from "./SearchResultContactItem.vue?vue&type=template&id=45b14c0a&scoped=true&"
import script from "./SearchResultContactItem.vue?vue&type=script&lang=js&"
export * from "./SearchResultContactItem.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultContactItem.vue?vue&type=style&index=0&id=45b14c0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b14c0a",
  null
  
)

export default component.exports